














































































































import { ValidationService } from '@/services';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ProjectAttachmentsComponet extends Vue {
  application = this.$store.state.application;
  showUpload = false;
  fileToDelete: any = null;
  showDelete = false;
  errorMessages = '';
  public files: any = [];

  get project(): any {
    return this.$store.getters['project/getProject']();
  }

  upload(): void {
    const projectId = this.project.id;
    const files = this.files;
    (this as any).$store.dispatch('project/uploadAttachments', { projectId, files }).then(() => {
      this.files = [];
      this.showUpload = false;
    });
  }

  handleDownloadAttachment(trustedFileName: string, fileName: string, id: number): void {
    const projectId = this.project.id;
    (this as any).$store.dispatch('project/downloadAttachment', { projectId, trustedFileName, fileName, id });
  }

  handleDeleteAttachment(): void {
    const projectId = this.project.id;
    const id = this.fileToDelete.id;
    (this as any).$store.dispatch('project/deleteAttachment', { projectId, id }).then(() => {
      this.showDelete = false;
    });
  }

  addDropFile(files: any): void {
    files.dataTransfer.files.forEach((file: any) => {
      this.files.push(file);
    });
  }

  validateFile(files: any): void {
    const error: any = [];

    files.forEach((file: any, index: number) => {
      const isValid = false;

      if (file.size > 104857600) {
        error.push(this.$t('attachments.errorSize', [file.name]));
        delete this.files[index];
      } else {
        ValidationService.isFileValid(file, (isValid: boolean) => {
          if (!isValid) {
            error.push(this.$t('attachments.errorExtension', [file.name]));
            delete this.files[index];
          }
        });
      }
    });

    this.files = this.files.filter((file: any) => !!file);
    this.errorMessages = error.join(', ');
  }

  openDeleteDialog(file: any): void {
    this.fileToDelete = file;
    this.showDelete = true;
  }

  closeDeleteDialog(): void {
    this.fileToDelete = null;
    this.showDelete = false;
  }

  getFileIcon(file: any) {
    const extension = file.name.split('.').pop();

    switch (extension) {
      case 'jpeg':
      case 'jpg':
      case 'png':
        return 'mdi-file-image-outline';
      case 'gif':
        return 'mdi-gif';
      case 'pdf':
        return 'mdi-file-pdf-outline';
      case 'xls':
      case 'xlsx':
        return 'mdi-file-excel-outline';
      case 'doc':
      case 'docx':
        return 'mdi-file-word-outline';
      default:
        return 'mdi-file-outline';
    }
  }
}
